module.exports = __webpack_public_path__ + "static/grandEst-66974fa6c8769c791ea2cac7902a67c5.png";